<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-stock-movement-multi-select-search-control [formControlName]="'stockMovement'"
                                                                [(ngModel)]="model.data.stockMovement">
                </wbo-stock-movement-multi-select-search-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-entity-group-by-report-criteria [showEmployeeOption]="true" [showInventoryOption]="true"
                                                     [showMovementOption]="true">
                </wbo-entity-group-by-report-criteria>
            </fui-column>
            <fui-column>
                <wbo-entity-sub-group-by-report-criteria [showOutletOption]="showOutletOption">
                </wbo-entity-sub-group-by-report-criteria>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
